import React, { useState } from "react";
import { Typography, Button, Link, SvgIcon } from "@mui/material";
import {
  Apple,
  Android,
  CreditCard,
  SportsEsports,
  EmojiEvents,
} from "@mui/icons-material";
import styled from "styled-components";
import { colors } from "../../../theme/colors";

import img1 from "../../../img/carrusel-1-home.jpg";
import img2 from "../../../img/carrusel-2-home.jpg";
import img3 from "../../../img/carrusel-3-home.jpg";

import { ReactComponent as AppstoreLogo } from "../../../img/svg/app-store.svg";
import { ReactComponent as PlayStoreLogo } from "../../../img/svg/google-play.svg";

import { ReactComponent as MedallaLogo } from "../../../img/svg/medalla-retos.svg";
import { ReactComponent as QuetzalLogo } from "../../../img/svg/quetzales-retos.svg";

import {
  DotButton,
  CarouselContainer,
  StackedImageContainer,
  TextContainer,
  MainContentContainer,
} from "./styled";

const carouselItems = [
  {
    id: 0,
    image: img1,
    title: "",
    description:
      "Paga tu luz desde Bi en Línea app, entra al sorteo y gana un TV, iPad o laptop. ¡Descárgala ya y transoforma tu rutina financiera.",
    icon: MedallaLogo,
    dotBg: img1,
  },
  {
    id: 1,
    image: img2,
    title: "Participa en nuestros retos mensuales",
    description:
      "Conviértete en un experto financiero completando misiones prácticas cada mes.",
    icon: SportsEsports,
    dotBg: img2,
  },
  {
    id: 2,
    image: img3,
    title: "Recibe recompensas exclusivas",
    description:
      "Entre más participas, más oportunidades tienes de ganar increíbles premios.",
    icon: QuetzalLogo,
    dotBg: img3,
  },
];

export default function CarouselFinanciero() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isChanging, setIsChanging] = useState(false);

  const handleDotClick = (index) => {
    if (index === activeIndex || isChanging) return;

    setIsChanging(true);

    setTimeout(() => {
      setActiveIndex(index);
      setIsChanging(false);
    }, 300);
  };

  const currentItem = carouselItems[activeIndex];

  return (
    <CarouselContainer style={{ padding: "2rem 1rem" }}>
      <div
        className="dots-container"
        style={{ display: "flex", flexDirection: "column" }}
      >
        {carouselItems.map((item, index) => {
          const IconComponent = item.icon;
          return (
            <DotButton
              key={index}
              active={activeIndex === index}
              bgImage={item.dotBg}
              onClick={() => handleDotClick(index)}
            >
              <IconComponent className="icon" />
            </DotButton>
          );
        })}
      </div>

      <div className="main-content">
        <MainContentContainer>
          <div className="image-section">
            <StackedImageContainer className={isChanging ? "changing" : ""}>
              <div className="image-stack image-1"></div>
              <div className="image-stack image-2"></div>
              <div className="image-stack image-3">
                <img
                  src={currentItem.image}
                  alt={currentItem.title}
                  className="main-image"
                />
              </div>
            </StackedImageContainer>
          </div>

          <div className="text-section">
            <TextContainer className={isChanging ? "changing" : ""}>
              <div className="title">
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    color: colors.primary,
                  }}
                >
                  {currentItem.title}
                </Typography>
              </div>

              <div className="description">
                <Typography
                  variant="h6"
                  sx={{ color: colors.primary, lineHeight: "28px" }}
                >
                  {currentItem.description}
                </Typography>
              </div>

              <div
                className="download-links"
                style={{ display: "flex", gap: "1rem" }}
              >
                <Link
                  id="btn-descarga-appstore-retos"
                  onClick={() => {
                    window.location.href =
                      "https://apps.apple.com/gt/app/bi-en-l%C3%ADnea/id510761055";
                  }}
                >
                  <SvgIcon
                    component={AppstoreLogo}
                    inheritViewBox
                    sx={{ width: "100px", color: "#000" }}
                  />
                </Link>
                <Link
                  id="btn-descarga-googleplay-retos"
                  onClick={() => {
                    window.location.href =
                      "https://play.google.com/store/apps/details?id=gt.com.bi.bienlinea&hl=es_GT&gl=US&pli=1";
                  }}
                >
                  <SvgIcon
                    component={PlayStoreLogo}
                    inheritViewBox
                    sx={{ width: "100px", color: "#000" }}
                  />
                </Link>
              </div>
            </TextContainer>
          </div>
        </MainContentContainer>
      </div>
    </CarouselContainer>
  );
}
